module.exports = __webpack_public_path__ + "img/9_1.8f602fe8.jpg";